import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@repletoryreach/sdk-auth';
import type { ReactElement, ReactNode } from 'react';
import { BootSplash } from '../components/BootSplash';

export function RequirePlatformAdmin({ children }: { children: ReactNode }): ReactElement {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <BootSplash />;
  }
  if (!user) {
    // `from` carries the path that was asked for; the sign-in form reads it
    // back so a bookmarked deep link survives the round trip through login.
    return <Navigate to="/auth/login" replace state={{ from: location.pathname + location.search }} />;
  }
  if (user.scope !== 'platform') {
    return <Navigate to="/auth/login" replace state={{ wrongDomain: true }} />;
  }
  return <>{children}</>;
}
